import { createSlice } from "@reduxjs/toolkit";
import { getRebates, getRebatesPNL } from "./thunk";
export const initialState = {
  // Get Rebates
  rebateList: [],
  isRebateListSuccess: false,
  getRebatesLoading: false,
  // Get PNL Share Rebates
  rebateListPNL: [],
  isRebatePNLListSuccess: false,
  getRebatesPNLLoading: false,
  // Error Handling
  error: {},
};

const RebateSlice = createSlice({
  name: "RebateSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get Rebates
    builder.addCase(getRebates.pending, (state) => {
      state.getRebatesLoading = true;
      state.error = false;
    });
    builder.addCase(getRebates.fulfilled, (state: any, action: any) => {
      state.rebateList = action.payload;
      state.isRebateListSuccess = true;
      state.getRebatesLoading = false;
      state.error = false;
    });
    builder.addCase(getRebates.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
      state.getRebatesLoading = false;
    });
    // Get PNL Share Rebates
    builder.addCase(getRebatesPNL.pending, (state) => {
      state.getRebatesPNLLoading = true;
      state.error = false;
    });
    builder.addCase(getRebatesPNL.fulfilled, (state: any, action: any) => {
      state.rebateListPNL = action.payload;
      state.isRebatePNLListSuccess = true;
      state.getRebatesPNLLoading = false;
      state.error = false;
    });
    builder.addCase(getRebatesPNL.rejected, (state: any, action: any) => {
      state.error = action.payload || null;
      state.getRebatesPNLLoading = false;
    });
  },
});

export default RebateSlice.reducer;
